import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Card KPI per il riepilogo totale conversazioni.
 * Mostra il numero totale e badge con la distribuzione per categoria.
 * @param {Object} props - Proprietà del componente
 * @param {number} props.totalConversations - Totale conversazioni nel periodo
 * @param {number} props.totalHandled - Conversazioni elaborate correttamente
 * @param {number} props.totalForwarded - Conversazioni inoltrate all'operatore
 * @param {number} props.totalErrors - Conversazioni con errori o escluse
 * @returns {JSX.Element} Card KPI conversazioni
 */
export const KpiConversationsCard = ({
  totalConversations,
  totalHandled,
  totalForwarded,
  totalErrors
}) => {
  return (
    <div className="ncard nkpi-card nkpi-card--blue">
      <div className="ncard__head">
        <div
          className="ncard__ico"
          style={{ background: 'var(--info-tint)', color: 'var(--primary-700)' }}
        >
          <i className="pi pi-comments" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.conversazioniTotali}</h3>
        </div>
      </div>
      <div className="ncard__body">
        <div className="nkpi__value" style={{ color: 'var(--primary-700)', fontSize: 36 }}>
          {totalConversations}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 10 }}>
          <span className="nbadge nbadge--ok">
            <span className="nbadge__dot" style={{ background: 'var(--success)' }} />
            {t.elaborate} {totalHandled}
          </span>
          <span className="nbadge nbadge--info">
            <span className="nbadge__dot" style={{ background: 'var(--primary)' }} />
            {t.inoltrate} {totalForwarded}
          </span>
          <span className="nbadge nbadge--err">
            <span className="nbadge__dot" style={{ background: 'var(--danger)' }} />
            {t.errori}: {totalErrors}
          </span>
        </div>
      </div>
    </div>
  )
}
